import { styled } from '@olxeu-jobs/ui';

export const Wrapper = styled('div', () => ({
  position: 'relative',
}));

export const TransparentLayer = styled('div', () => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: 'rgba(255, 255, 255, 0.5)',
}));
